import { keysToCamelCase } from "@jti/fe-common";
import type { MagentoApiGetCountryQueryResponse } from "@jti/magento-api-v2";
import type { MagentoCountry } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCountryEndpoint = (builder: MagentoApiBuilder) => ({
  getCountry: builder.query<MagentoCountry, string>({
    query: (id) => ({
      method: "getCountry",
      params: [{ id }],
    }),
    providesTags: [TAGS.COUNTRY],
    transformResponse: (response: MagentoApiGetCountryQueryResponse) =>
      keysToCamelCase(response.country) as MagentoCountry,
  }),
});
